import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getDeletion } from './versionApi';
import { DeletionRequest, isDeletionActive } from './versionTypes';
import { GENERATION_POLL_MS } from './generationTypes';
import { generationKeys } from './useGenerationQueries';
import { versionKeys } from './useVersionQueries';
export function useDeletionJob(request: DeletionRequest | null) {
  const client = useQueryClient();
  const id = request?.id;
  const version = request?.version;
  const query = useQuery({
    queryKey: versionKeys.deletion(id), enabled: id !== undefined,
    retry: false, refetchOnWindowFocus: false,
    queryFn: ({ signal }) => {
      if (!id || !version) throw new Error('Удаление не выбрано.');
      return getDeletion(id, version, signal);
    },
    refetchInterval: (query) => query.state.status === 'success' && query.state.data && isDeletionActive(query.state.data) ? GENERATION_POLL_MS : false,
  });
  const job = query.isSuccess ? query.data : undefined;
  const terminal = job && !isDeletionActive(job) ? `${job.id}:${job.status}` : null;
  useEffect(() => {
    if (!terminal) return;
    void client.invalidateQueries({ queryKey: versionKeys.all });
    void client.invalidateQueries({ queryKey: generationKeys.current });
    void client.invalidateQueries({ queryKey: generationKeys.history });
    void client.invalidateQueries({ queryKey: [...generationKeys.all, 'blockers'] });
  }, [client, terminal]);
  return query;
}
